import { useMediaQuery } from '@vueuse/core'

export const useMobile = () => useMediaQuery('(max-width: 640px)')
export const useTablet = () => useMediaQuery('(max-width: 991px)')
